// export { default } from './courses.container';
export { default } from './bulletin-board.container';



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/index.js